/**
 * PocketFiler - German (de) Translation File
 * Complete translation - all keys from en.js
 */

const de = {
  "nav.login": "Anmelden",
  "nav.signup": "Loslegen",
  "nav.logout": "Abmelden",
  "nav.dashboard": "Dashboard",
  "nav.virtualOffices": "Virtuelle Büros",
  "nav.clients": "Kunden",
  "nav.deals": "Deals",
  "nav.documents": "Dokumente",
  "nav.messages": "Nachrichten",
  "nav.settings": "Einstellungen",
  "nav.invoices": "Rechnungen",
  "nav.templates": "Vorlagen",
  "nav.tasks": "Aufgaben",
  "nav.meetings": "Besprechungen",
  "nav.analytics": "Analytik",
  "landing.badge": "KI-gestützte Deal-Plattform",
  "landing.hero.title": "Schließen Sie wichtige Deals in jeder Sprache ab",
  "landing.hero.titleHighlight": "mit KI",
  "landing.hero.subtitle": "PocketFiler hilft Unternehmen und Einzelpersonen bei dokumentenintensiven, vertrauenswürdigen Transaktionen – vom globalen Handel bis hin zu lokalen Autoverkäufen und Versicherungspolicen – mit KI-Übersetzung, Dokumenten-Workflows und Deal Rooms für jeden Deal.",
  "landing.hero.cta.start": "Kostenlos starten",
  "landing.hero.cta.demo": "So funktioniert es",
  "landing.useCases.title": "Entwickelt für globalen Handel, lokale Dienstleistungen und große persönliche Deals",
  "landing.useCases.subtitle": "Ob Sie Waren aus dem Ausland importieren oder Ihr Auto in der Stadt verkaufen, PocketFiler gibt Ihnen die Werkzeuge, um sicher abzuschließen.",
  "landing.useCases.globalTrade.title": "Globaler Handel & Fertigung",
  "landing.useCases.globalTrade.desc": "Finden Sie Lieferanten im Ausland, sammeln Sie Compliance-Dokumente und verhandeln Sie in Deal Rooms mit Echtzeit-Übersetzung.",
  "landing.useCases.insurance.title": "Versicherung, Kredite & Professionelle Dienste",
  "landing.useCases.insurance.desc": "Laden Sie Kunden ein, Ausweise, Kontoauszüge und Formulare in ihrer Sprache hochzuladen, dann verfolgen Sie jedes Dokument und jede Nachricht in virtuellen Büros.",
  "landing.useCases.realEstate.title": "Immobilien & Grundstücksgeschäfte",
  "landing.useCases.realEstate.desc": "Führen Sie Käufer und Mieter durch Anträge, Offenlegungen und Verträge in verschiedenen Sprachen, alles in einem Deal Room pro Transaktion.",
  "landing.useCases.vehicle.title": "Private Fahrzeug- & Vermögensverkäufe",
  "landing.useCases.vehicle.desc": "Nutzen Sie Deal Rooms und KI-generierte Verträge für Kaufverträge und Dokumentation von Autos, Ausrüstung und anderen wertvollen Gegenständen.",
  "landing.audience.title": "Entwickelt für Einzelpersonen und Teams",
  "landing.audience.individuals.title": "Für Einzelpersonen",
  "landing.audience.individuals.bullet1": "Schließen Sie wichtige einmalige Deals wie Autokäufe, Ausrüstung oder hochwertige Gegenstände mit klaren Aufzeichnungen ab.",
  "landing.audience.individuals.bullet2": "Verwenden Sie einfache sichere Links, um Dokumente hochzuladen und Verträge von Ihrem Handy zu überprüfen.",
  "landing.audience.individuals.bullet3": "Bewahren Sie alle Nachrichten, Dateien und Vertragsentwürfe für jeden Deal an einem Ort auf, auch nach Abschluss des Deals.",
  "landing.audience.teams.title": "Für Unternehmen & Teams",
  "landing.audience.teams.bullet1": "Richten Sie virtuelle Büros für jede Dienstleistungslinie ein (Versicherung, Immobilien, Kredite, Importe) mit maßgeschneiderten Checklisten.",
  "landing.audience.teams.bullet2": "Laden Sie Kunden in jeder Sprache ein, Dokumente hochzuladen, Verträge zu unterschreiben und in Deal Rooms zu kommunizieren.",
  "landing.audience.teams.bullet3": "Geben Sie Ihrem Team einen gemeinsamen Arbeitsbereich mit Zeitachsen, KI-Zusammenfassungen und vollständiger Historie für jede Transaktion.",
  "landing.howItWorks.title": "Wie PocketFiler für jeden Deal funktioniert",
  "landing.howItWorks.subtitle": "Vier leistungsstarke Funktionen, die zusammenarbeiten, um Ihnen zu helfen, Deals schneller und mit weniger Reibung abzuschließen.",
  "landing.howItWorks.concierge.title": "KI-Concierge",
  "landing.howItWorks.concierge.desc": "Ihr KI-Assistent lernt Ihr Geschäft kennen, richtet die richtigen virtuellen Büros ein und konfiguriert Dokumenten-Checklisten für jeden Deal-Typ.",
  "landing.howItWorks.translation.title": "Auto-Übersetzung",
  "landing.howItWorks.translation.desc": "Nachrichten und wichtige Inhalte werden sofort zwischen den Parteien übersetzt, damit Käufer, Verkäufer und Kunden in ihrer eigenen Sprache kommunizieren können.",
  "landing.howItWorks.documents.title": "Intelligente Dokumente",
  "landing.howItWorks.documents.desc": "Kunden laden Dokumente von ihrem Handy hoch; KI extrahiert Schlüsselfelder, prüft die Qualität und markiert Probleme, bevor sie einen Deal verzögern.",
  "landing.howItWorks.dealRooms.title": "Deal Rooms & Verträge",
  "landing.howItWorks.dealRooms.desc": "Jeder Deal erhält einen eigenen Raum mit Zeitachse, Nachrichten, Dokumenten und KI-generierten Vertragsentwürfen, die Sie überprüfen und finalisieren können.",
  "landing.cta.title": "Bereit für Ihren nächsten Deal?",
  "landing.cta.subtitle": "Schließen Sie sich Unternehmen und Einzelpersonen an, die PocketFiler nutzen, um wichtige Transaktionen sicher abzuwickeln.",
  "landing.cta.button": "Kostenloses Konto erstellen",
  "landing.footer.tagline": "Wichtige Deals einfach gemacht.",
  "language.picker.title": "Wählen Sie Ihre Sprache",
  "language.picker.subtitle": "Wir zeigen Ihnen alle Anweisungen, Nachrichten und Verträge in dieser Sprache. Andere können ihre eigene Sprache wählen; KI übernimmt die Übersetzung für Sie.",
  "language.picker.continue": "Weiter",
  "language.picker.playSample": "Beispiel abspielen",
  "language.picker.playing": "Wird abgespielt...",
  "language.picker.confirmation": "Sie haben {language} gewählt. Wir zeigen Ihnen alles in dieser Sprache. Andere Parteien können ihre eigene Sprache wählen; PocketFiler übersetzt Nachrichten, Dokumente und Verträge, damit alle verstehen.",
  "language.toast.saved": "Sprache gespeichert! Um sie zu ändern, gehen Sie zu Einstellungen in Ihrem Profil.",
  "language.confirm.title": "Sprache bestätigen",
  "language.confirm.subtitle": "Diese Sprache wird für alle UI, Nachrichten und Verträge verwendet.",
  "language.confirm.change": "Sprache ändern",
  "language.confirm.continue": "Weiter mit",
  "language.confirm.chineseNote": "Hinweis: Sie haben vereinfachtes Chinesisch (简体中文) gewählt. Wenn Sie traditionelles Chinesisch bevorzugen, ändern Sie bitte Ihre Auswahl.",
  "auth.login.title": "Willkommen zurück",
  "auth.login.subtitle": "Melden Sie sich bei Ihrem PocketFiler-Konto an",
  "auth.login.email": "E-Mail",
  "auth.login.password": "Passwort",
  "auth.login.submit": "Anmelden",
  "auth.login.noAccount": "Noch kein Konto?",
  "auth.login.signupLink": "Registrieren",
  "auth.login.error": "Ungültige E-Mail oder Passwort",
  "auth.signup.title": "Konto erstellen",
  "auth.signup.subtitle": "Starten Sie Deals in jeder Sprache",
  "auth.signup.name": "Vollständiger Name",
  "auth.signup.email": "E-Mail",
  "auth.signup.password": "Passwort",
  "auth.signup.confirmPassword": "Passwort bestätigen",
  "auth.signup.companyName": "Firmenname",
  "auth.signup.companyType": "Branche",
  "auth.signup.submit": "Konto erstellen",
  "auth.signup.hasAccount": "Haben Sie bereits ein Konto?",
  "auth.signup.loginLink": "Anmelden",
  "auth.signup.terms": "Mit der Registrierung stimmen Sie unseren Nutzungsbedingungen und der Datenschutzrichtlinie zu.",
  "dashboard.title": "Dashboard",
  "dashboard.welcome": "Willkommen zurück, {name}",
  "dashboard.aiSummary.title": "KI-Zusammenfassung",
  "dashboard.aiSummary.generating": "Zusammenfassung wird erstellt...",
  "dashboard.stats.totalDeals": "Gesamt Deals",
  "dashboard.stats.activeDeals": "Aktive Deals",
  "dashboard.stats.totalClients": "Gesamt Kunden",
  "dashboard.stats.documentsProcessed": "Verarbeitete Dokumente",
  "dashboard.recentDeals.title": "Aktuelle Deals",
  "dashboard.recentDeals.viewAll": "Alle anzeigen",
  "dashboard.recentDeals.empty": "Noch keine Deals. Erstellen Sie Ihren ersten Deal, um zu beginnen.",
  "dashboard.recentClients.title": "Aktuelle Kunden",
  "dashboard.recentClients.viewAll": "Alle anzeigen",
  "dashboard.recentClients.empty": "Noch keine Kunden. Laden Sie Ihren ersten Kunden ein, um zu beginnen.",
  "dashboard.quickActions.title": "Schnellaktionen",
  "dashboard.quickActions.createDeal": "Deal erstellen",
  "dashboard.quickActions.inviteClient": "Kunden einladen",
  "dashboard.quickActions.createOffice": "Virtuelles Büro erstellen",
  "offices.title": "Virtuelle Büros",
  "offices.subtitle": "Organisieren Sie Ihr Geschäft nach Dienstleistungsart",
  "offices.create": "Virtuelles Büro erstellen",
  "offices.empty.title": "Noch keine virtuellen Büros",
  "offices.empty.desc": "Erstellen Sie Ihr erstes virtuelles Büro, um Deals und Kunden zu organisieren.",
  "offices.card.clients": "{count} Kunden",
  "offices.card.deals": "{count} Deals",
  "offices.card.checklist": "Checklisten-Punkte",
  "offices.checklist": "Dokumenten-Checkliste",
  "offices.noChecklist": "Keine Dokumente erforderlich",
  "offices.dialog.title": "Virtuelles Büro erstellen",
  "offices.dialog.desc": "Richten Sie einen neuen Arbeitsbereich für eine bestimmte Dienstleistungsart ein",
  "offices.dialog.name": "Büroname",
  "offices.dialog.namePlaceholder": "z.B. Versicherungsansprüche, Immobilienverkäufe",
  "offices.dialog.type": "Bürotyp",
  "offices.dialog.description": "Beschreibung",
  "offices.dialog.descriptionPlaceholder": "Beschreiben Sie, was dieses Büro bearbeitet...",
  "offices.dialog.checklist": "Dokumenten-Checkliste",
  "offices.dialog.checklistHelp": "KI-generierte Checkliste für erforderliche Dokumente",
  "offices.dialog.addItem": "Element hinzufügen",
  "offices.dialog.generateChecklist": "Mit KI generieren",
  "offices.dialog.creating": "Wird erstellt...",
  "offices.dialog.create": "Büro erstellen",
  "offices.form.name": "Büroname",
  "offices.form.namePlaceholder": "z.B. Versicherungsdienste, Immobilien usw.",
  "offices.form.description": "Beschreibung",
  "offices.form.descPlaceholder": "Welche Art von Deals wird dieses Büro bearbeiten?",
  "offices.form.checklistPlaceholder": "Erforderliches Dokument hinzufügen...",
  "offices.ai.title": "KI-gestütztes Setup",
  "offices.ai.desc": "Lassen Sie unseren KI-Concierge Ihnen helfen, das perfekte virtuelle Büro einzurichten, indem er nach Ihren Geschäftsanforderungen fragt.",
  "offices.ai.manual": "Manuell einrichten",
  "offices.ai.start": "KI-Setup starten",
  "offices.ai.startOnboarding": "Hilf mir, mein virtuelles Büro einzurichten",
  "offices.ai.suggestion": "KI-Vorschlag",
  "offices.ai.acceptSuggestion": "Akzeptieren & Büro erstellen",
  "offices.ai.inputPlaceholder": "Geben Sie Ihre Antwort ein...",
  "clients.title": "Kunden",
  "clients.subtitle": "Verwalten Sie Ihre Kunden und Einladungen",
  "clients.invite": "Kunden einladen",
  "clients.empty.title": "Noch keine Kunden",
  "clients.empty.desc": "Laden Sie Ihren ersten Kunden ein, um zu beginnen.",
  "clients.table.name": "Name",
  "clients.table.client": "Kunde",
  "clients.table.contact": "Kontakt",
  "clients.table.office": "Büro",
  "clients.table.language": "Sprache",
  "clients.table.status": "Status",
  "clients.table.actions": "Aktionen",
  "clients.status.invited": "Eingeladen",
  "clients.status.active": "Aktiv",
  "clients.status.completed": "Abgeschlossen",
  "clients.dialog.title": "Neuen Kunden einladen",
  "clients.dialog.name": "Kundenname",
  "clients.dialog.email": "E-Mail-Adresse",
  "clients.dialog.phone": "Telefonnummer",
  "clients.dialog.office": "Virtuelles Büro",
  "clients.dialog.language": "Bevorzugte Sprache",
  "clients.dialog.sending": "Einladung wird gesendet...",
  "clients.dialog.send": "Einladung senden",
  "clients.toast.invited": "Einladung an {name} gesendet",
  "clients.toast.deleted": "Kunde gelöscht",
  "clients.toast.linkCopied": "Einladungslink in die Zwischenablage kopiert",
  "clients.invite.step1Title": "Neuen Kunden einladen",
  "clients.invite.step2Title": "Einladungsnachricht Vorschau",
  "clients.invite.step3Title": "Einladung gesendet!",
  "clients.invite.step1Desc": "Kontaktinformationen des Kunden eingeben",
  "clients.invite.step2Desc": "Einladungsnachricht überprüfen und anpassen",
  "clients.invite.step3Desc": "Teilen Sie den Einladungslink mit Ihrem Kunden",
  "clients.invite.nameLabel": "Kundenname",
  "clients.invite.namePlaceholder": "z.B. Max Mustermann",
  "clients.invite.contactMethod": "Kontaktmethode",
  "clients.invite.phone": "Telefonnummer",
  "clients.invite.customNote": "Eigene Notiz",
  "clients.invite.customNotePlaceholder": "Besondere Anweisungen für diesen Kunden...",
  "clients.invite.previewMessage": "Nachrichtenvorschau",
  "clients.invite.aiGenerated": "KI-generierte Einladungsnachricht",
  "clients.invite.messagePreview": "Nachrichtenvorschau",
  "clients.invite.messageEditHint": "Sie können diese Nachricht vor dem Senden bearbeiten",
  "clients.invite.documentsRequested": "Angeforderte Dokumente",
  "clients.invite.regenerate": "Nachricht neu generieren",
  "clients.invite.sendInvite": "Einladung senden",
  "clients.invite.linkCreated": "Einladungslink erstellt!",
  "clients.invite.linkCopiedToClipboard": "Der Link wurde in die Zwischenablage kopiert",
  "clients.invite.shareLink": "Teilen Sie diesen Link mit Ihrem Kunden per E-Mail, SMS oder persönlich",
  "clients.invite.inviteAnother": "Weiteren einladen",
  "clients.invite.success": "Kunde eingeladen!",
  "clients.invite.linkCopied": "Einladungslink kopiert!",
  "clients.invite.yourAgent": "Ihr Agent",
  "clients.invite.defaultOffice": "Unser Büro",
  "deals.title": "Deals",
  "deals.subtitle": "Verfolgen und verwalten Sie Ihre Transaktionen",
  "deals.create": "Deal erstellen",
  "deals.empty.title": "Noch keine Deals",
  "deals.empty.desc": "Erstellen Sie Ihren ersten Deal, um zu beginnen.",
  "deals.search": "Deals suchen...",
  "deals.filter.all": "Alle Deals",
  "deals.filter.active": "Aktiv",
  "deals.filter.pending": "Ausstehend",
  "deals.filter.closed": "Abgeschlossen",
  "deals.column.draft": "Entwurf",
  "deals.column.active": "Aktiv",
  "deals.column.pending": "Ausstehend",
  "deals.column.closed": "Abgeschlossen",
  "deals.card.documents": "{count} Dokumente",
  "deals.card.messages": "{count} Nachrichten",
  "deals.dialog.title": "Neuen Deal erstellen",
  "deals.dialog.dealTitle": "Deal-Titel",
  "deals.dialog.dealTitlePlaceholder": "z.B. Fahrzeugkauf - Honda Civic 2023",
  "deals.dialog.client": "Kunde",
  "deals.dialog.office": "Virtuelles Büro",
  "deals.dialog.type": "Deal-Typ",
  "deals.dialog.notes": "Notizen",
  "deals.dialog.notesPlaceholder": "Notizen zu diesem Deal hinzufügen...",
  "deals.dialog.creating": "Wird erstellt...",
  "deals.dialog.create": "Deal erstellen",
  "dealRoom.back": "Zurück zu Deals",
  "dealRoom.readOnly.title": "Nur Lesen",
  "dealRoom.readOnly.closedMessage": "Dieser Deal wurde abgeschlossen. Der Deal Room ist jetzt nur zur Referenz und für Prüfungszwecke lesbar.",
  "dealRoom.readOnly.cancelledMessage": "Dieser Deal wurde storniert. Der Deal Room ist jetzt nur zur Referenz und für Prüfungszwecke lesbar.",
  "dealRoom.tabs.messages": "Nachrichten",
  "dealRoom.tabs.documents": "Dokumente",
  "dealRoom.tabs.contract": "Vertrag",
  "dealRoom.timeline.title": "Aktivitätszeitachse",
  "dealRoom.timeline.empty": "Noch keine Aktivität",
  "dealRoom.details.title": "Deal-Details",
  "dealRoom.details.notes": "Notizen",
  "dealRoom.details.type": "Typ",
  "dealRoom.details.documents": "Dokumente",
  "dealRoom.details.messages": "Nachrichten",
  "dealRoom.aiSummary.title": "KI-Zusammenfassung",
  "dealRoom.aiSummary.generating": "Zusammenfassung wird erstellt...",
  "dealRoom.messages.empty": "Noch keine Nachrichten. Starten Sie das Gespräch.",
  "dealRoom.messages.placeholder": "Nachricht eingeben...",
  "dealRoom.messages.send": "Senden",
  "dealRoom.messages.sending": "Wird gesendet...",
  "dealRoom.messages.showOriginal": "Original anzeigen",
  "dealRoom.messages.showTranslation": "Übersetzung anzeigen",
  "dealRoom.messages.translatedFrom": "Übersetzt aus {language}",
  "dealRoom.messages.suggestReply": "Antwort vorschlagen",
  "dealRoom.documents.empty": "Noch keine Dokumente hochgeladen.",
  "dealRoom.documents.upload": "Dokument hochladen",
  "dealRoom.documents.uploading": "Wird hochgeladen...",
  "dealRoom.documents.analyze": "Analysieren",
  "dealRoom.documents.analyzing": "Wird analysiert...",
  "dealRoom.documents.download": "Herunterladen",
  "dealRoom.documents.delete": "Löschen",
  "dealRoom.documents.pending": "Analyse ausstehend",
  "dealRoom.documents.analyzed": "Analysiert",
  "dealRoom.documents.aiAnalysis": "KI-Dokumentenanalyse",
  "dealRoom.documents.type": "Dokumenttyp",
  "dealRoom.documents.confidence": "Konfidenz",
  "dealRoom.documents.summary": "Zusammenfassung",
  "dealRoom.documents.issues": "Probleme",
  "dealRoom.contract.empty.title": "Noch kein Vertrag erstellt",
  "dealRoom.contract.empty.desc": "Erstellen Sie einen KI-Vertragsentwurf für diesen Deal.",
  "dealRoom.contract.generate": "Vertragsentwurf erstellen",
  "dealRoom.contract.regenerate": "Vertrag neu erstellen",
  "dealRoom.contract.generating": "Wird erstellt...",
  "dealRoom.contract.aiLabel": "KI-generierter Vertragsentwurf",
  "dealRoom.contract.language": "Sprache",
  "dealRoom.contract.copy": "Kopieren",
  "dealRoom.contract.copied": "In Zwischenablage kopiert",
  "dealRoom.contract.type": "Vertragstyp",
  "dealRoom.contract.generated": "Erstellt",
  "dealRoom.contract.languages": "Sprachen",
  "dealRoom.contract.status": "Status",
  "dealRoom.contract.notice": "KI-Dokumentenanalyse: Eine oder mehrere Klauseln haben kein direktes Äquivalent zwischen den gewählten Sprachen. Wir haben beschreibende Sprache verwendet. Bitte überprüfen Sie diese Abschnitte sorgfältig und bestätigen Sie bei Bedarf mit der anderen Partei.",
  "dealRoom.contract.dialog.title": "Vertragsentwurf erstellen",
  "dealRoom.contract.dialog.desc": "KI erstellt einen zweisprachigen Vertrag basierend auf den Deal-Details.",
  "dealRoom.contract.dialog.disclaimer": "Dies ist ein KI-generierter Entwurf zur Überprüfung. Lassen Sie ihn vor der Unterzeichnung von einem Rechtsexperten prüfen.",
  "dealRoom.contract.dialog.type": "Vertragstyp",
  "dealRoom.contract.dialog.languages": "Sprachen",
  "dealRoom.contract.dialog.languagesHelp": "Wählen Sie zwei Sprachen für Ihren zweisprachigen Vertrag. Alle Tier 1 Sprachen werden vollständig unterstützt.",
  "dealRoom.contract.dialog.primary": "Primär",
  "dealRoom.contract.dialog.secondary": "Sekundär",
  "dealRoom.contract.dialog.terms": "Besondere Bedingungen",
  "dealRoom.contract.dialog.termsPlaceholder": "Fügen Sie besondere Bedingungen hinzu...",
  "dealRoom.contract.dialog.generate": "Vertrag erstellen",
  "dealRoom.contract.dialog.generating": "Wird erstellt...",
  "dealRoom.status.change": "Status ändern",
  "dealRoom.status.dialog.title": "Deal-Status ändern",
  "dealRoom.status.dialog.from": "Von",
  "dealRoom.status.dialog.to": "Nach",
  "dealRoom.status.dialog.reason": "Grund (optional)",
  "dealRoom.status.dialog.reasonPlaceholder": "Warum ändern Sie den Status?",
  "dealRoom.status.dialog.confirm": "Änderung bestätigen",
  "dealRoom.status.dialog.changing": "Wird geändert...",
  "dealRoom.status.toast.changed": "Status geändert zu {status}",
  "dealRoom.upgrade.title": "Auf Business upgraden",
  "dealRoom.upgrade.desc": "Vertragserstellung erfordert einen Business-Plan.",
  "dealRoom.upgrade.features": "Mit Business erhalten Sie:",
  "dealRoom.upgrade.feature1": "KI-generierte Vertragsentwürfe",
  "dealRoom.upgrade.feature2": "Erweiterte Dokumentenanalyse",
  "dealRoom.upgrade.feature3": "Prioritäts-Support",
  "dealRoom.upgrade.button": "Jetzt upgraden",
  "settings.title": "Einstellungen",
  "settings.subtitle": "Verwalten Sie Ihr Konto und Ihre Organisation",
  "settings.tabs.profile": "Profil",
  "settings.tabs.organization": "Organisation",
  "settings.profile.title": "Profileinstellungen",
  "settings.profile.subtitle": "Verwalten Sie Ihre persönlichen Informationen",
  "settings.profile.name": "Vollständiger Name",
  "settings.profile.email": "E-Mail",
  "settings.profile.emailNote": "E-Mail kann nicht geändert werden",
  "settings.profile.language": "Bevorzugte Sprache",
  "settings.profile.languageHelp": "Alle UI, Nachrichten und Verträge werden in dieser Sprache angezeigt.",
  "settings.profile.save": "Änderungen speichern",
  "settings.profile.saving": "Wird gespeichert...",
  "settings.profile.saved": "Profil aktualisiert",
  "settings.org.title": "Organisationseinstellungen",
  "settings.org.subtitle": "Verwalten Sie Ihre Geschäftsinformationen",
  "settings.org.name": "Organisationsname",
  "settings.org.type": "Branche",
  "settings.org.billingEmail": "Rechnungs-E-Mail",
  "settings.org.plan": "Plan",
  "settings.org.verification": "Verifizierungsstatus",
  "settings.org.save": "Änderungen speichern",
  "settings.org.saving": "Wird gespeichert...",
  "settings.org.saved": "Organisation aktualisiert",
  "settings.org.noOrg": "Keine Organisation gefunden",
  "invite.language.title": "Wählen Sie Ihre Sprache",
  "invite.language.subtitle": "Wir zeigen Ihnen alle Anweisungen in Ihrer Sprache.",
  "invite.welcome.title": "Willkommen bei",
  "invite.welcome.subtitle": "Wir sind bereit, Ihre Dokumente zu empfangen.",
  "invite.welcome.time": "5-10 Minuten",
  "invite.welcome.timeLabel": "Geschätzte Zeit",
  "invite.welcome.secure": "Sicher und Kostenlos",
  "invite.welcome.secureDesc": "Ihre Dokumente sind verschlüsselt. Dieser Service ist für Sie kostenlos.",
  "invite.welcome.start": "Upload starten",
  "invite.documents.needed": "Benötigte Dokumente",
  "invite.upload.title": "Dokument hochladen",
  "invite.upload.dragDrop": "Ziehen Sie eine Datei hierher oder klicken Sie zum Auswählen",
  "invite.upload.or": "oder",
  "invite.upload.takePhoto": "Bilder",
  "invite.upload.browse": "Dateien",
  "invite.upload.uploading": "Wird hochgeladen...",
  "invite.upload.analyzing": "Dokument wird überprüft...",
  "invite.upload.success": "Erfolgreich hochgeladen",
  "invite.upload.next": "Nächstes Dokument",
  "invite.upload.finish": "Alle überprüfen",
  "invite.upload.skip": "Jetzt überspringen",
  "invite.upload.progress": "Fortschritt",
  "invite.complete.title": "Fertig!",
  "invite.complete.subtitle": "Ihre Dokumente wurden erfolgreich eingereicht.",
  "invite.complete.message": "Wir haben alle Ihre Dokumente erhalten. Sie werden bald kontaktiert.",
  "invite.complete.summary": "Eingereichte Dokumente",
  "invite.complete.securityNote": "Ihre Dokumente werden sicher gespeichert und sind nur für autorisiertes Personal zugänglich.",
  "invite.chat.title": "Chat mit Ihrem Agenten",
  "invite.chat.placeholder": "Nachricht eingeben...",
  "invite.chat.empty": "Noch keine Nachrichten. Starten Sie ein Gespräch.",
  "invite.chat.sent": "Ihre Nachricht wurde gesendet.",
  "invite.chat.willRespond": "Wir werden so schnell wie möglich antworten.",
  "invite.chat.sending": "Wird gesendet...",
  "invite.error.title": "Ungültiger oder abgelaufener Link",
  "invite.error.message": "Dieser Einladungslink ist nicht mehr gültig. Bitte wenden Sie sich an den Absender für einen neuen Link.",
  "common.loading": "Wird geladen...",
  "common.save": "Speichern",
  "common.cancel": "Abbrechen",
  "common.delete": "Löschen",
  "common.edit": "Bearbeiten",
  "common.create": "Erstellen",
  "common.close": "Schließen",
  "common.dismiss": "Schließen",
  "common.confirm": "Bestätigen",
  "common.back": "Zurück",
  "common.next": "Weiter",
  "common.previous": "Zurück",
  "common.of": "von",
  "common.search": "Suchen",
  "common.filter": "Filter",
  "common.sort": "Sortieren",
  "common.viewAll": "Alle anzeigen",
  "common.refresh": "Aktualisieren",
  "common.retry": "Erneut versuchen",
  "common.yes": "Ja",
  "common.no": "Nein",
  "common.or": "oder",
  "common.and": "und",
  "common.optional": "optional",
  "common.required": "erforderlich",
  "status.draft": "Entwurf",
  "status.active": "Aktiv",
  "status.pending": "Ausstehend",
  "status.pending_documents": "Dokumente ausstehend",
  "status.pending_signature": "Unterschrift ausstehend",
  "status.on_hold": "Pausiert",
  "status.closed": "Abgeschlossen",
  "status.cancelled": "Storniert",
  "error.generic": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
  "error.network": "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.",
  "error.unauthorized": "Sie sind nicht berechtigt, diese Aktion durchzuführen.",
  "error.notFound": "Die angeforderte Ressource wurde nicht gefunden.",
  "error.validation": "Bitte überprüfen Sie Ihre Eingabe und versuchen Sie es erneut.",
  "error.serverError": "Serverfehler. Bitte versuchen Sie es später erneut.",
  "success.saved": "Änderungen erfolgreich gespeichert.",
  "success.created": "Erfolgreich erstellt.",
  "success.deleted": "Erfolgreich gelöscht.",
  "success.sent": "Erfolgreich gesendet.",
  "success.uploaded": "Erfolgreich hochgeladen.",
  "time.justNow": "Gerade eben",
  "time.minutesAgo": "vor {count} Minuten",
  "time.hoursAgo": "vor {count} Stunden",
  "time.daysAgo": "vor {count} Tagen",
  "time.today": "Heute",
  "time.yesterday": "Gestern",
  "dealRoom.notFound": "Deal nicht gefunden",
  "dealRoom.loading": "Deal wird geladen...",
  "dealRoom.conversation.title": "Deal-Konversation",
  "dealRoom.conversation.you": "Sie",
  "dealRoom.conversation.client": "Kunde",
  "dealRoom.messages.hideOriginal": "Original ausblenden",
  "dealRoom.messages.original": "Original ({language})",
  "dealRoom.messages.disabled": "Nachrichten sind für diesen Deal-Status deaktiviert",
  "dealRoom.messages.aiSuggest": "KI-vorgeschlagene Antwort",
  "dealRoom.documents.title": "Dokumente",
  "dealRoom.documents.uploadDisabled": "Upload deaktiviert",
  "dealRoom.documents.pendingAnalysis": "Analyse ausstehend",
  "dealRoom.documents.uploadFirst": "Erstes Dokument hochladen",
  "dealRoom.documents.uploadHelp": "Laden Sie Dokumente für die KI-Analyse hoch",
  "dealRoom.documents.uploadDisabledHelp": "Dokumenten-Upload ist für diesen Deal-Status deaktiviert",
  "dealRoom.documents.analyzeWithAI": "Mit KI analysieren",
  "dealRoom.documents.notAnalyzed": "Noch nicht analysiert",
  "dealRoom.documents.notAnalyzedHelp": "Führen Sie eine KI-Analyse durch, um Dokumenttyp und Felder zu extrahieren und Erkenntnisse zu gewinnen",
  "dealRoom.documents.analyzeDocument": "Dokument analysieren",
  "dealRoom.documents.extractedFields": "Extrahierte Felder",
  "dealRoom.documents.issuesDetected": "Erkannte Probleme",
  "dealRoom.documents.preview": "Vorschau",
  "dealRoom.documents.uploaded": "Hochgeladen",
  "dealRoom.documents.deleteConfirm": "Sind Sie sicher, dass Sie dieses Dokument löschen möchten?",
  "dealRoom.onHold.message": "Dieser Deal ist pausiert. Dokumenten-Uploads sind deaktiviert. Sie können weiterhin Nachrichten zur Koordination senden.",
  "dealRoom.pendingSignature.message": "Der Vertrag ist zur Unterschrift bereit. Dokumenten-Uploads sind deaktiviert, bis der Vertrag unterzeichnet oder zurückgesetzt wird.",
  "dealRoom.status.current": "aktuell",
  "dealRoom.status.finalWarning": "Dies ist ein Endzustand. Der Deal kann nach dieser Aktion nicht wieder geöffnet werden.",
  "dealRoom.contract.purchaseAgreement": "Kaufvertrag",
  "dealRoom.contract.purchaseAgreementDesc": "Standard-Kaufvertrag",
  "dealRoom.contract.noContract": "Noch kein Vertrag",
  "dealRoom.contract.noContractDesc": "Erstellen Sie einen KI-gestützten Vertragsentwurf basierend auf Ihren Deal-Details und Dokumenten.",
  "dealRoom.contract.notAvailable": "Vertragserstellung ist für {status} Deals nicht verfügbar.",
  "dealRoom.contract.locked": "Vertragserstellung ist gesperrt, während auf Unterschrift gewartet wird.",
  "dealRoom.contract.requiresPlan": "Erfordert Business Starter Plan",
  "dealRoom.toast.dealUpdated": "Deal aktualisiert",
  "dealRoom.toast.statusChanged": "Deal-Status geändert zu {status}",
  "dealRoom.toast.statusFailed": "Statusänderung fehlgeschlagen",
  "dealRoom.toast.contractGenerated": "Vertragsentwurf erfolgreich erstellt",
  "dealRoom.toast.contractCopied": "{language} Vertrag in Zwischenablage kopiert",
  "dealRoom.toast.messageFailed": "Nachricht konnte nicht gesendet werden",
  "dealRoom.toast.suggestionFailed": "Vorschlag konnte nicht erstellt werden",
  "dealRoom.toast.documentUploaded": "Dokument hochgeladen",
  "dealRoom.toast.uploadFailed": "Upload fehlgeschlagen",
  "dealRoom.toast.analysisComplete": "KI-Dokumentenanalyse abgeschlossen",
  "dealRoom.toast.analysisFailed": "KI-Analyse fehlgeschlagen",
  "dealRoom.toast.documentDeleted": "Dokument gelöscht",
  "dealRoom.toast.deleteFailed": "Löschen fehlgeschlagen",
  "dealRoom.details.created": "Erstellt",
  "dealRoom.details.addNotes": "Deal-Notizen hinzufügen...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "Jetzt überspringen",
  "onboarding.badge": "KI-gestütztes Setup",
  "onboarding.welcome": "Willkommen, {name}!",
  "onboarding.welcomeGeneric": "Willkommen!",
  "onboarding.subtitle": "Lassen Sie uns Ihren PocketFiler-Arbeitsbereich einrichten. Erzählen Sie unserem KI-Concierge von Ihrem Geschäft, und wir konfigurieren alles für Sie.",
  "onboarding.step1": "Beschreiben Sie Ihr Geschäft und Ihre Bedürfnisse",
  "onboarding.step2": "KI schlägt Ihr Setup vor",
  "onboarding.step3": "Starten Sie mit der Deal-Verwaltung",
  "onboarding.concierge.title": "KI-Concierge",
  "onboarding.toast.officeCreated": "Virtuelles Büro erstellt!",
  "auth.signup.accountType": "Kontotyp",
  "auth.signup.passwordTooShort": "Passwort muss mindestens 8 Zeichen lang sein",
  "auth.signup.passwordsDoNotMatch": "Passwörter stimmen nicht überein",
  "auth.signup.success": "Konto erfolgreich erstellt!",
  "captions.connecting": "Verbinden...",
  "captions.disable": "Untertitel deaktivieren",
  "captions.enable": "Untertitel aktivieren",
  "captions.error.connect": "Verbindung zum Untertiteldienst fehlgeschlagen",
  "captions.error.toggle": "Untertitel konnten nicht umgeschaltet werden",
  "captions.language": "Untertitelsprache",
  "captions.live": "Live",
  "captions.off": "Untertitel Aus",
  "captions.on": "Untertitel Ein",
  "captions.original": "Original",
  "captions.translated": "Übersetzt",
  "captions.translating": "Übersetzen...",
  "clients.joined.empty.desc": "Sie sind noch keinen Organisationen beigetreten. Bitten Sie diese, Sie zu ihrem PocketFiler-Arbeitsbereich einzuladen.",
  "clients.joined.empty.title": "Keine Organisationen beigetreten",
  "clients.nav.joinedOrgs": "Beigetretene Organisationen",
  "clients.nav.myClients": "Meine Kunden",
  "clients.table.joinedDate": "Beitrittsdatum",
  "clients.table.organization": "Organisation",
  "common.backToHome": "Zurück zur Startseite",
  "common.deleteConfirmDesc": "Diese Aktion kann nicht rückgängig gemacht werden. Dies wird das Element dauerhaft löschen und Daten von unseren Servern entfernen.",
  "common.deleteConfirmTitle": "Sind Sie sich absolut sicher?",
  "common.noResults": "Keine Ergebnisse gefunden",
  "connect.createAccount": "Kostenloses Konto erstellen",
  "connect.dealCreated": "Deal erfolgreich erstellt",
  "connect.error.invalid": "Ungültiger Verbindungslink",
  "connect.error.invalidDesc": "Dieser Verbindungslink ist ungültig oder abgelaufen.",
  "connect.error.server": "Etwas ist schiefgelaufen",
  "connect.error.serverDesc": "Bitte versuchen Sie es später erneut.",
  "connect.infoUnauth": "Diese Person verwendet PocketFiler, um sprachübergreifende Deals und Dokumente sicher zu verwalten.",
  "connect.joinOffice": "Virtuellem Büro beitreten",
  "connect.loggedInAs": "Angemeldet als",
  "connect.login": "Anmelden",
  "connect.startDeal": "Deal starten",
  "connect.titleAuth": "Sie verbinden sich mit",
  "connect.titleUnauth": "Verbinden mit",
  "connect.typeOrg": "Organisation",
  "connect.typePerson": "Person",
  "contacts.actions.call": "Anrufen",
  "contacts.actions.email": "E-Mail",
  "contacts.actions.message": "In-App-Nachricht senden",
  "contacts.actions.noEmail": "Keine E-Mail-Adresse",
  "contacts.actions.noPhone": "Keine Telefonnummer",
  "contacts.actions.sms": "SMS",
  "contacts.actions.title": "Kontakt {name}",
  "contacts.actions.whatsapp": "WhatsApp",
  "contacts.dialog.name": "Kontaktname",
  "contacts.dialog.title": "Neuen Kontakt hinzufügen",
  "contacts.empty.desc": "Fügen Sie Ihren ersten Kontakt hinzu, um zu beginnen.",
  "contacts.empty.title": "Noch keine Kontakte",
  "contacts.invite": "Kontakt hinzufügen",
  "contacts.invite.customNotePlaceholder": "Besondere Notizen zu diesem Kontakt...",
  "contacts.invite.nameLabel": "Kontaktname",
  "contacts.invite.shareLink": "Teilen Sie diesen Link mit Ihrem Kontakt per E-Mail, SMS oder persönlich",
  "contacts.invite.step1Desc": "Kontaktinformationen eingeben",
  "contacts.invite.step1Title": "Neuen Kontakt hinzufügen",
  "contacts.subtitle": "Verwalten Sie Ihre Kontakte und Einladungen",
  "contacts.table.contact": "Kontakt",
  "contacts.title": "Kontakte",
  "contacts.toast.deleted": "Kontakt gelöscht",
  "contacts.toast.invited": "Kontakt hinzugefügt: {name}",
  "contacts.toast.linkCopied": "Link in Zwischenablage kopiert",
  "dashboard.quickActions.inviteContact": "Kontakt hinzufügen",
  "dashboard.recentContacts.empty": "Noch keine Kontakte. Laden Sie Ihren ersten Kontakt ein, um zu beginnen.",
  "dashboard.recentContacts.title": "Aktuelle Kontakte",
  "dashboard.recentContacts.viewAll": "Alle anzeigen",
  "dashboard.stats.totalContacts": "Kontakte gesamt",
  "dealRoom.contract.analysisWarning": "Einige Dokumente wurden noch nicht analysiert. KI-Analyse verbessert die Vertragsgenauigkeit.",
  "dealRoom.conversation.colleague": "Kollege",
  "dealRoom.details.clients": "Kunden",
  "dealRoom.documents.previewNotAvailable": "Vorschau nicht verfügbar. Wird heruntergeladen...",
  "dealRoom.incomingCall.accept": "Annehmen",
  "dealRoom.incomingCall.decline": "Ablehnen",
  "dealRoom.incomingCall.inProgress": "Anruf läuft",
  "dealRoom.incomingCall.started": "{name} hat einen Anruf gestartet",
  "dealRoom.messages.connecting": "Verbindung zum Chat wird hergestellt...",
  "dealRoom.messages.connectionError": "Verbindung zur Unterhaltung nicht möglich.",
  "dealRoom.pendingSignature.loading": "Unterschriftsstatus wird geladen...",
  "dealRoom.pendingSignature.signedWaitingOthers": "Erfolgreich unterschrieben. Warten auf andere Teilnehmer.",
  "dealRoom.readOnly.completedMessage": "Dieser Deal wurde erfolgreich abgeschlossen. Der Deal-Room ist nun schreibgeschützt für Referenz- und Prüfzwecke.",
  "dealRoom.signature.signed": "Unterschrieben",
  "dealRoom.signature.signedByYou": "Von Ihnen unterschrieben",
  "dealRoom.signature.success": "Vertrag erfolgreich unterschrieben!",
  "dealRoom.signaturesList.clients": "Kunden",
  "dealRoom.signaturesList.dealOwner": "Deal-Eigentümer",
  "dealRoom.signaturesList.pending": "Ausstehend",
  "dealRoom.signaturesList.signedOn": "Unterschrieben am",
  "dealRoom.signaturesList.title": "Unterschriften",
  "dealRoom.signaturesList.viewSignatures": "Unterschriften anzeigen",
  "dealRoom.signedByAll.addPayment": "Zahlung hinzufügen",
  "dealRoom.signedByAll.message": "Von allen Teilnehmern unterschrieben. Mit Zahlung fortfahren.",
  "dealRoom.timeline.createdBy": "von {name}",
  "deals.tabs.all": "Alle Deals",
  "deals.tabs.my": "Meine Deals",
  "deals.validation.clientRequired": "Bitte wählen Sie mindestens einen Kunden aus",
  "deals.validation.notesLength": "Notizen dürfen maximal 200 Zeichen lang sein",
  "deals.validation.titleLength": "Titel darf maximal 100 Zeichen lang sein",
  "deals.validation.titleRequired": "Deal-Titel ist erforderlich",
  "documents.readAloud.analyzeFirst": "Analysieren Sie dieses Dokument zuerst, um es vorlesen zu lassen.",
  "documents.readAloud.error": "Vorlesen fehlgeschlagen",
  "documents.readAloud.title": "Vorlesen",
  "landing.cta.secondary": "Beispiel-Deal-Room ansehen",
  "landing.hero.trust": "Kostenloser Plan. Keine Kreditkarte erforderlich. 11 Sprachen unterstützt.",
  "landing.socialProof": "Vertraut von über 500 Unternehmen in 40 Ländern",
  "landing.useCases.personal.desc": "Schließen Sie wichtige einmalige Geschäfte wie Fahrzeuge, Ausrüstung oder Immobilien mit klaren Aufzeichnungen, KI-Verträgen und einfachen sicheren Links zum Dokumentenaustausch ab.",
  "landing.useCases.personal.title": "Hochwertige private Transaktionen",
  "landing.useCases.professional.desc": "Laden Sie Kunden ein, Dokumente mit KI-Unterstützung hochzuladen, verfolgen Sie jede Interaktion in sicheren virtuellen Büros und erstellen Sie zweisprachige digitale Verträge – alles aus einem Arbeitsbereich.",
  "landing.useCases.professional.subtitle": "Versicherung, Immobilien, Kredite",
  "landing.useCases.professional.title": "Professionelle Dienstleistungen",
  "livekit.call": "Anruf",
  "livekit.connecting": "Verbinden...",
  "livekit.error.connect": "Verbindung zum Anruf fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "livekit.error.connection": "Verbindungsfehler. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut.",
  "livekit.error.permission": "Sie haben keine Berechtigung, an diesem Anruf teilzunehmen.",
  "livekit.hint": "Sprechen Sie in diesem Deal, statt die App zu wechseln.",
  "livekit.inCall": "Im Anruf",
  "livekit.joinCall": "Anruf beitreten",
  "livekit.leaveCall": "Anruf verlassen",
  "livekit.participant": "Teilnehmer",
  "livekit.participants": "Teilnehmer",
  "messages.readAloud.error": "Vorlesen fehlgeschlagen",
  "messages.readAloud.title": "Vorlesen",
  "nav.companyProfile": "Firmenprofil",
  "nav.contacts": "Kontakte",
  "nav.directory": "Verzeichnis",
  "nav.products": "Produkte",
  "offices.card.contacts": "{count} Kontakte",
  "pwa.banner.install": "Installieren",
  "pwa.banner.subtitle": "Schnellerer Zugriff, funktioniert offline",
  "pwa.banner.title": "PocketFiler App holen",
  "pwa.firefox.hint": "In Firefox suchen Sie nach dem Installationssymbol (⊕) in der Adressleiste, um diese App zu Ihrem Desktop hinzuzufügen.",
  "pwa.installApp": "App installieren",
  "pwa.installed": "App erfolgreich installiert!",
  "pwa.ios.description": "Fügen Sie PocketFiler zu Ihrem Home-Bildschirm für die beste Erfahrung hinzu:",
  "pwa.ios.gotIt": "Verstanden",
  "pwa.ios.inToolbar": "in Ihrer Browser-Symbolleiste",
  "pwa.ios.inTopRight": "in der oberen rechten Ecke",
  "pwa.ios.shareButton": "Teilen-Schaltfläche",
  "pwa.ios.step1": "Tippen Sie auf die",
  "pwa.ios.step2": "Scrollen Sie nach unten und tippen Sie auf",
  "pwa.ios.step3": "Tippen Sie auf",
  "pwa.ios.title": "PocketFiler installieren",
  "pwa.iosHint": "Tippen Sie auf das Teilen-Symbol und \"Zum Home-Bildschirm hinzufügen\", um PocketFiler zu installieren.",
  "pwa.opera.chromeHint": "öffnen Sie diese Seite, dann klicken Sie auf das Installationssymbol in der Adressleiste",
  "pwa.opera.desktopNotSupported": "Opera Desktop unterstützt keine PWA-Installation. Um PocketFiler als App zu installieren, öffnen Sie es bitte in Google Chrome oder Microsoft Edge.",
  "pwa.opera.edgeHint": "öffnen Sie diese Seite, dann klicken Sie auf das Installationssymbol (⊕) in der Adressleiste",
  "pwa.opera.mobileAddPage": "Seite hinzufügen zu",
  "pwa.opera.mobileDescription": "Tippen Sie auf das + Symbol am unteren Rand von Opera oder verwenden Sie das Menü unten:",
  "pwa.opera.mobileHomeScreen": "Home-Bildschirm",
  "pwa.opera.mobileStep1": "Tippen Sie auf das",
  "pwa.opera.mobileStep1b": "Plus (+) Symbol in der unteren Leiste von Opera",
  "pwa.opera.mobileStep2": "Oder tippen Sie auf",
  "pwa.opera.mobileTitle": "PocketFiler in Opera installieren",
  "pwa.opera.recommendedBrowsers": "Verwenden Sie stattdessen:",
  "pwa.opera.title": "In Opera nicht verfügbar",
  "qr.clickToExpand": "Klicken für Vollbildansicht",
  "qr.copied": "Kopiert!",
  "qr.copyLink": "Link kopieren",
  "qr.description": "Zeigen Sie diesen Code Kunden oder Partnern. Wenn sie ihn scannen, können sie sich mit Ihnen verbinden und in Sekunden einen Deal starten.",
  "qr.download": "Herunterladen",
  "qr.generate": "QR-Code generieren",
  "qr.linkCopied": "Link in Zwischenablage kopiert",
  "qr.primaryLanguage": "Hauptsprache",
  "qr.regenerate": "Zurücksetzen",
  "qr.regenerated": "QR-Code neu generiert. Alte Links sind nun ungültig.",
  "qr.scanInstructions": "Scannen Sie diesen QR-Code mit PocketFiler oder einem beliebigen QR-Scanner, um sich zu verbinden.",
  "qr.scanToConnect": "Scannen zum Verbinden",
  "qr.share": "Teilen",
  "qr.title": "Teilen Sie Ihren PocketFiler QR-Code",
  "qr.yourLink": "Ihr Verbindungslink:",
  "recording.completed": "Aufzeichnung abgeschlossen",
  "recording.confirmDelete": "Diese Aufzeichnung löschen?",
  "recording.delete": "Löschen",
  "recording.deleted": "Aufzeichnung gelöscht",
  "recording.download": "Herunterladen",
  "recording.error.delete": "Aufzeichnung konnte nicht gelöscht werden",
  "recording.error.noCall": "Kein aktiver Anruf. Bitte treten Sie zuerst dem Anruf bei.",
  "recording.error.start": "Aufzeichnung konnte nicht gestartet werden",
  "recording.error.stop": "Aufzeichnung konnte nicht gestoppt werden",
  "recording.failed": "Aufzeichnung fehlgeschlagen",
  "recording.noRecordings": "Noch keine Aufzeichnungen",
  "recording.play": "Abspielen",
  "recording.playback": "Aufzeichnung abspielen",
  "recording.processing": "Verarbeitung...",
  "recording.start": "Aufzeichnen",
  "recording.started": "Aufzeichnung gestartet",
  "recording.stop": "Stopp",
  "recording.stopped": "Aufzeichnung gestoppt. Verarbeitung...",
  "recording.viewRecordings": "Aufzeichnungen anzeigen",
  "schedule.button": "Planen",
  "schedule.cancel": "Abbrechen",
  "schedule.chooseDateTime": "Bitte wählen Sie Datum und Uhrzeit",
  "schedule.create": "Planen",
  "schedule.created": "Geplant",
  "schedule.dateTime": "Datum & Uhrzeit",
  "schedule.description": "Wählen Sie Datum und Uhrzeit. Sie können dem Anruf beitreten, wenn es Zeit ist.",
  "schedule.title": "Anruf oder Aufzeichnung planen",
  "schedule.type": "Typ",
  "schedule.typeCall": "Anruf",
  "schedule.typeRecording": "Aufzeichnung",
  "schedule.upcoming": "Anstehende Termine",
  "settings.profile.accountType": "Kontotyp",
  "settings.profile.accountTypeHelp": "Wählen Sie den Typ, der Sie am besten beschreibt",
  "settings.tabs.sharing": "QR teilen",
  "support.askAI": "KI fragen",
  "support.availableTimes": "Verfügbare Zeiten",
  "support.booked": "Anruf erfolgreich geplant!",
  "support.bookingConfirmed": "Perfekt, ich habe Ihren Anruf für {time} geplant. Sie erhalten eine Bestätigung mit dem Anruflink. Kann ich Ihnen sonst noch helfen?",
  "support.bookingError": "Terminbuchung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "support.clearChat": "Chat löschen",
  "support.error": "Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
  "support.inYourTime": "in Ihrer Ortszeit",
  "support.inputPlaceholder": "Geben Sie Ihre Frage ein...",
  "support.openChat": "KI-Support öffnen",
  "support.scheduleCall": "Anruf mit Support planen",
  "support.scheduleTitle": "Support-Anruf planen",
  "support.slotsError": "Verfügbare Zeiten konnten nicht geladen werden.",
  "support.subtitle": "Fragen Sie alles über PocketFiler",
  "support.title": "KI-Support",
  "support.welcome": "Hallo! Ich bin der PocketFiler KI-Assistent. Ich kann Ihnen helfen bei:\\n\\n- Erstellen und Verwalten von Deals\\n- Senden von Dokumenten zur Unterschrift\\n- Verwendung der QR-Verbindungsfunktion\\n- Einladen von Kunden\\n- Allen anderen Fragen zu PocketFiler\\n\\nWie kann ich Ihnen heute helfen?",
  "support.yourTimezone": "Ihre Zeitzone",
  "validation.emailInvalid": "Ungültiges E-Mail-Format",
  "validation.emailRequired": "E-Mail ist erforderlich",
  "validation.nameRequired": "Name ist erforderlich",
  "validation.nameTooLong": "Name muss weniger als 50 Zeichen lang sein",
  "validation.noteTooLong": "Notiz muss weniger als 200 Zeichen lang sein",
  "validation.phoneInvalid": "Ungültige Telefonnummer (10-15 Ziffern)",
  "validation.phoneRequired": "Telefonnummer ist erforderlich",
  "deals.column.cancelled": "Storniert",
  "deals.column.completed": "Abgeschlossen",
  "deals.column.disputed": "Angefochten",
  "deals.column.escrow_funded": "Treuhandkonto finanziert",
  "deals.column.on_hold": "Pausiert",
  "deals.column.pending_documents": "Dokumente ausstehend",
  "deals.column.pending_payment": "Zahlung ausstehend",
  "deals.column.pending_signature": "Unterschrift ausstehend",
  "deals.column.release_requested": "Freigabe angefordert",
  "dashboard.actions.addClient": "Kunde hinzufügen",
  "dashboard.actions.all": "Alle",
  "dashboard.actions.createContract": "Vertrag erstellen",
  "dashboard.actions.createInvoice": "Rechnung erstellen",
  "dashboard.actions.customize": "Anpassen",
  "dashboard.actions.newDeal": "Neuer Deal",
  "dashboard.actions.scheduleMeeting": "Termin planen",
  "dashboard.actions.uploadDocument": "Dokument hochladen",
  "dashboard.actions.viewAll": "Alle anzeigen",
  "dashboard.briefing.default": "Momentan nichts Dringendes. Ihr Arbeitsbereich ist in gutem Zustand.",
  "dashboard.briefing.title": "Tägliche Zusammenfassung",
  "dashboard.empty.activity": "Keine kürzlichen Aktivitäten.",
  "dashboard.empty.deals": "Noch keine Deals vorhanden. Erstellen Sie Ihren ersten Deal, um die Pipeline zu sehen.",
  "dashboard.empty.documents": "Alle Dokumente sind auf dem neuesten Stand.",
  "dashboard.empty.meetings": "Keine anstehenden Termine.",
  "dashboard.empty.tasks": "Keine offenen Aufgaben.",
  "dashboard.greeting.afternoon": "Guten Tag",
  "dashboard.greeting.evening": "Guten Abend",
  "dashboard.greeting.morning": "Guten Morgen",
  "dashboard.greeting.subtitle": "Hier ist, was in Ihrem Arbeitsbereich passiert.",
  "dashboard.stats.documents": "Dokumente",
  "dashboard.stats.invoicesDue": "Fällige Rechnungen",
  "dashboard.stats.meetingsComing": "Anstehende Termine",
  "dashboard.stats.tasksDue": "Fällige Aufgaben",
  "dashboard.stats.unreadMessages": "Ungelesene Nachrichten",
  "dashboard.widgets.dealPipeline": "Deal-Pipeline",
  "dashboard.widgets.documentsAttention": "Dokumente, die Aufmerksamkeit benötigen",
  "dashboard.widgets.gettingStarted": "Erste Schritte",
  "dashboard.widgets.quickActions": "Schnellaktionen",
  "dashboard.widgets.recentActivity": "Kürzliche Aktivitäten",
  "dashboard.widgets.tasks": "Aufgaben",
  "dashboard.widgets.upcomingMeetings": "Anstehende Termine",
  "dashboard.steps.createDeal": "Erstellen Sie Ihren ersten Deal",
  "dashboard.steps.addClient": "Einen Kunden hinzufügen",
  "dashboard.steps.uploadDocument": "Ein Dokument hochladen",
  "dashboard.steps.scheduleMeeting": "Ein Meeting planen",
  "dashboard.steps.createInvoice": "Eine Rechnung erstellen",
  "dashboard.steps.addLogo": "Ihr Logo hinzufügen",
  "dashboard.steps.complete": "abgeschlossen",
  "dashboard.time.overdue": "Überfällig",
  "dashboard.time.today": "Heute",
  "dashboard.time.tomorrow": "Morgen",
  "dashboard.time.noDate": "Kein Datum",
  "dashboard.docReason.sent": "Gesendet, Antwort ausstehend",
  "dashboard.docReason.notAnalyzed": "Noch nicht analysiert",
  "dashboard.docReason.draft": "Entwurf, nicht abgeschlossen",
  "dashboard.docReason.needsReview": "Überprüfung erforderlich",
  "docViewer.notFound": "Dokument nicht gefunden",
  "docViewer.previewUnavailable": "Vorschau für diesen Dateityp nicht verfügbar",
  "docViewer.aiAnalysis": "AI-Analyse",
  "docViewer.documentType": "Dokumenttyp",
  "docViewer.summary": "Zusammenfassung",
  "docViewer.extractedFields": "Extrahierte Felder",
  "docViewer.issues": "Probleme",
  "docViewer.tags": "Tags",
  "docViewer.noPreviousVersions": "Keine vorherigen Versionen",
  "docViewer.noActivity": "Noch keine Aktivität",
  "auth.forgotPassword.title": "Passwort zurücksetzen",
  "guestSign.loading": "Vertrag wird geladen...",
  "guestSign.unableToLoad": "Vertrag kann nicht geladen werden",
  "guestSign.signed": "Vertrag unterzeichnet",
  "guestSign.createOwn": "Möchten Sie eigene Verträge erstellen und verwalten?",
  "guestSign.secureSign": "Sichere Unterzeichnung",
  "meeting.ended": "Diese Besprechung ist beendet",
  "meeting.cancelled": "Besprechung abgesagt",
  "meeting.notFound": "Besprechung nicht gefunden",
  "meeting.joiningAs": "Beitritt als",
  "meeting.yourName": "Ihr Name *",
  "meeting.emailOptional": "E-Mail (optional)",
  "notFound.title": "Seite nicht gefunden",
  "notFound.dashboard": "Zum Dashboard",
  "notFound.home": "Startseite",
  "auth.resetPassword.invalidLink": "Ungültiger Link",
  "auth.resetPassword.title": "Neues Passwort festlegen",
  "templates.category": "Kategorie",
  "templates.legal": "Rechtliches",
  "templates.sales": "Vertrieb",
  "templates.services": "Dienstleistungen",
  "templates.finance": "Finanzen",
  "templates.library": "Vorlagenbibliothek",
  "templates.libraryDesc": "Sofort einsetzbare Dokumentvorlagen für Ihr Unternehmen",
  "templates.noDefault": "Keine Standardvorlagen entsprechen Ihrer Suche.",
  "templates.noCustom": "Keine benutzerdefinierten Vorlagen gefunden",
  "templates.delete": "Vorlage löschen",
  "templates.cancel": "Abbrechen",
  "uploadRequest.notFound": "Anfrage nicht gefunden",
  "uploadRequest.error": "Etwas ist schiefgelaufen",
  "uploadRequest.errorDesc": "Bitte versuchen Sie es später erneut oder kontaktieren Sie die Person, die diese Anfrage gesendet hat.",
  "uploadRequest.uploaded": "Dokumente hochgeladen!",
  "uploadRequest.title": "Dokument-Upload-Anfrage",
  "uploadRequest.fileTypes": "PDF, Bilder, Word-Dokumente - max. 25MB",
  "verify.verifying": "E-Mail wird verifiziert...",
  "verify.success": "E-Mail verifiziert!",
  "verify.signIn": "Anmelden",
  "verify.alreadyVerified": "Bereits verifiziert",
  "verify.invalidLink": "Ungültiger Link",
  "verify.backToLogin": "Zurück zur Anmeldung",
  "documents.documents": "Dokumente",
  "documents.allStatus": "Alle Status",
  "documents.newFolder": "Neuer Ordner",
  "documents.clear": "Löschen",
  "documents.noDocumentsYet": "Noch keine Dokumente vorhanden",
  "documents.status": "Status",
  "documents.type": "Typ",
  "documents.uploadedBy": "Hochgeladen von",
  "documents.previewNotAvailable": "Vorschau nicht verfügbar",
  "documents.aiAnalysis": "KI-Analyse",
  "documents.documentType": "Dokumenttyp",
  "documents.summary": "Zusammenfassung",
  "documents.extractedFields": "Extrahierte Felder",
  "documents.issues": "Probleme",
  "documents.notYetAnalyzed": "Noch nicht analysiert",
  "documents.details": "Details",
  "documents.size": "Größe",
  "documents.date": "Datum",
  "documents.mimeType": "MIME-Typ",
  "documents.noTags": "Keine Tags",
  "documents.changeStatus": "Status ändern",
  "documents.versionHistory": "Versionsverlauf",
  "documents.noPreviousVersions": "Keine vorherigen Versionen",
  "documents.activityLog": "Aktivitätsprotokoll",
  "documents.noActivityRecordedYet": "Noch keine Aktivität aufgezeichnet",
  "documents.uploadDocuments": "Dokumente hochladen",
  "documents.dragAndDropFiles": "Dateien per Drag & Drop ziehen oder klicken zum Durchsuchen. PDF, Bilder, Word-Dokumente werden unterstützt.",
  "documents.shareDocument": "Dokument teilen",
  "documents.done": "Fertig",
  "documents.emailOptional": "E-Mail (optional)",
  "documents.leaveEmptyToJust": "Leer lassen, um nur einen Link zu generieren",
  "documents.messageOptional": "Nachricht (optional)",
  "documents.cancel": "Abbrechen",
  "documents.requestDocuments": "Dokumente anfordern",
  "documents.sendASecureUpload": "Senden Sie einen sicheren Upload-Link per E-Mail an einen Kunden.",
  "documents.clientEmail": "Kunden-E-Mail *",
  "documents.clientName": "Kundenname",
  "documents.requestedDocuments": "Angeforderte Dokumente *",
  "documents.renameFolder": "Ordner umbenennen",
  "documents.selectADestinationFolder": "Wählen Sie einen Zielordner aus.",
  "documents.deleteDocument": "Dokument löschen?",
  "settings.individual": "Einzelperson",
  "settings.business": "Unternehmen",
  "settings.buyer": "Käufer",
  "settings.seller": "Verkäufer",
  "settings.chooseYourPreferredTheme": "Wählen Sie Ihr bevorzugtes Design",
  "settings.light": "Hell",
  "settings.dark": "Dunkel",
  "settings.system": "System",
  "settings.manufacturing": "Fertigung",
  "settings.insurance": "Versicherung",
  "settings.realEstate": "Immobilien",
  "settings.automotive": "Automobilindustrie",
  "settings.importexport": "Import/Export",
  "settings.other": "Sonstiges",
  "settings.brandingWhitelabel": "Branding & White-Label",
  "settings.customizeThePocketfilerExperience": "Passen Sie die PocketFiler-Erfahrung für Ihre Kunden an.",
  "settings.organizationLogo": "Organisationslogo",
  "settings.provideADirectLink": "Geben Sie einen direkten Link zu Ihrem transparenten PNG- oder SVG-Logo an.",
  "settings.primaryThemeColor": "Primäre Designfarbe",
  "settings.selectAHexColor": "Wählen Sie einen Hex-Farbcode aus, der die primären Akzente Ihrer Marke repräsentiert.",
  "settings.accentHoverColor": "Akzent-/Hover-Farbe",
  "settings.selectAHexColor1": "Wählen Sie eine Hex-Farbe für Hover-Zustände, Hervorhebungen und Akzentelemente aus.",
  "settings.customDomain": "Benutzerdefinierte Domain",
  "settings.ensureYouConfigureA": "Stellen Sie sicher, dass Sie einen CNAME-Eintrag konfigurieren, der auf pocketfiler.com verweist.",
  "settings.cancellationScheduled": "Kündigung geplant",
  "settings.yourLastPaymentFailed": "Ihre letzte Zahlung ist fehlgeschlagen. Bitte aktualisieren Sie Ihre Zahlungsmethode, um den Zugang zu behalten.",
  "settings.chooseYourPlan": "Wählen Sie Ihren Tarif",
  "settings.monthly": "Monatlich",
  "settings.save20": "20% sparen",
  "settings.current": "Aktuell",
  "settings.popular": "Beliebt",
  "settings.contactSales": "Vertrieb kontaktieren",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "Synchronisieren Sie Ihre PocketFiler-Termine mit Google Calendar",
  "settings.settingsPageErrorDebug": "Einstellungsseiten-Fehler (Debug)",
  "invoices.createInvoice": "Rechnung erstellen",
  "invoices.createANewInvoice": "Erstellen Sie eine neue Rechnung für einen Kunden",
  "invoices.selectClient": "Kunde auswählen",
  "invoices.dueDate": "Fälligkeitsdatum",
  "invoices.clientName": "Kundenname",
  "invoices.clientEmail": "Kunden-E-Mail",
  "invoices.lineItems": "Positionen",
  "invoices.description": "Beschreibung",
  "invoices.qty": "Anz.",
  "invoices.price": "Preis",
  "invoices.tax": "Steuer %",
  "invoices.total": "Gesamt",
  "invoices.subtotal": "Zwischensumme:",
  "invoices.discount": "Rabatt:",
  "invoices.tax1": "Steuer:",
  "invoices.total1": "Gesamt:",
  "invoices.notesOptional": "Notizen (optional)",
  "invoices.invoices": "Rechnungen",
  "invoices.manageAndTrackYour": "Verwalten und verfolgen Sie Ihre Rechnungen",
  "invoices.totalInvoiced": "Gesamtrechnungsbetrag",
  "invoices.paid": "Bezahlt",
  "invoices.outstanding": "Ausstehend",
  "invoices.totalInvoices": "Rechnungen insgesamt",
  "invoices.allInvoices": "Alle Rechnungen",
  "invoices.myInvoices": "Meine Rechnungen",
  "invoices.receivedInvoices": "Erhaltene Rechnungen",
  "invoices.noInvoicesYet": "Noch keine Rechnungen vorhanden",
  "meetings.join": "Beitreten",
  "meetings.end": "Beenden",
  "meetings.meetingTitle": "Besprechungstitel",
  "meetings.date": "Datum",
  "meetings.time": "Uhrzeit",
  "meetings.duration": "Dauer",
  "meetings.repeat": "Wiederholen",
  "meetings.doesNotRepeat": "Wird nicht wiederholt",
  "meetings.weekly": "Wöchentlich",
  "meetings.every2Weeks": "Alle 2 Wochen",
  "meetings.monthly": "Monatlich",
  "meetings.invitePeopleOptional": "Personen einladen (optional)",
  "meetings.cancel": "Abbrechen",
  "meetings.meetings": "Besprechungen",
  "companyprofile.companyProfile": "Unternehmensprofil",
  "companyprofile.manageYourBusinessProfile": "Verwalten Sie Ihr Geschäftsprofil und Ihr Team",
  "companyprofile.publicProfile": "Öffentliches Profil",
  "companyprofile.basicInformation": "Grundlegende Informationen",
  "companyprofile.essentialDetailsAboutYour": "Wesentliche Details zu Ihrem Unternehmen",
  "companyprofile.companyName": "Firmenname",
  "companyprofile.tagline": "Slogan",
  "companyprofile.industry": "Branche",
  "companyprofile.companyType": "Unternehmenstyp",
  "companyprofile.description": "Beschreibung",
  "companyprofile.companyDetails": "Unternehmensdetails",
  "companyprofile.additionalInformationAboutYour": "Zusätzliche Informationen zu Ihrem Unternehmen",
  "companyprofile.yearEstablished": "Gründungsjahr",
  "companyprofile.numberOfEmployees": "Anzahl der Mitarbeiter",
  "companyprofile.certifications": "Zertifizierungen",
  "companyprofile.enterCertificationsSeparatedBy": "Geben Sie Zertifizierungen getrennt durch Kommas ein",
  "companyprofile.languagesSpoken": "Gesprochene Sprachen",
  "companyprofile.shippingRegions": "Versandregionen",
  "companyprofile.contactInformation": "Kontaktinformationen",
  "companyprofile.howPotentialPartnersCan": "Wie potenzielle Partner Sie erreichen können",
  "companyprofile.website": "Website",
  "companyprofile.email": "E-Mail",
  "companyprofile.phone": "Telefon",
  "companyprofile.country": "Land",
  "companyprofile.city": "Stadt",
  "companyprofile.address": "Adresse",
  "companyprofile.teamMembers": "Teammitglieder",
  "companyprofile.manageUsersWithinYour": "Verwalten Sie Benutzer innerhalb Ihrer Organisation",
  "companyprofile.role": "Rolle",
  "companyprofile.admin": "Administrator",
  "companyprofile.member": "Mitglied",
  "companyprofile.viewer": "Betrachter",
  "companyprofile.titleOptional": "Titel (optional)",
  "companyprofile.name": "Name",
  "companyprofile.title": "Titel",
  "companyprofile.status": "Status",
  "companyprofile.actions": "Aktionen",
  "companyprofile.owner": "Inhaber",
  "companyprofile.copyInviteLink": "Einladungslink kopieren",
  "companyprofile.removeMember": "Mitglied entfernen",
  "companyprofile.removeTeamMember": "Teammitglied entfernen",
  "companyprofile.cancel": "Abbrechen",
  "products.productsServices": "Produkte & Dienstleistungen",
  "products.description": "Beschreibung",
  "products.pricing": "Preisgestaltung",
  "products.price": "Preis",
  "products.unit": "Einheit",
  "products.details": "Details",
  "products.minOrderQty": "Mindestbestellmenge",
  "products.leadTime": "Lieferzeit",
  "products.category": "Kategorie",
  "products.currency": "Währung",
  "products.leadTimeDays": "Lieferzeit (Tage)",
  "products.active": "Aktiv",
  "products.showInCatalog": "Im Katalog anzeigen",
  "products.cancel": "Abbrechen",
  "developersettings.reveal": "Anzeigen",
  "developersettings.copy": "Kopieren",
  "developersettings.hide": "Ausblenden",
  "developersettings.securityWarning": "Sicherheitswarnung",
  "developersettings.neverShareThisKey": "Teilen Sie diesen Schlüssel niemals öffentlich oder in clientseitigem Code",
  "developersettings.anyoneWithThisKey": "Jeder mit diesem Schlüssel kann Ihre Daten lesen und ändern",
  "developersettings.ifCompromisedRevokeImmediately": "Falls kompromittiert, widerrufen Sie ihn sofort und generieren Sie einen neuen Schlüssel",
  "developersettings.iUnderstandAndAccept": "Ich verstehe und übernehme die Verantwortung für die Sicherheit dieses Schlüssels",
  "developersettings.cancel": "Abbrechen",
  "developersettings.revealKey": "Schlüssel anzeigen",
  "developersettings.accessDenied": "Zugriff verweigert",
  "developersettings.onlyBusinessAccountsHave": "Nur Geschäftskonten haben Zugriff auf die Entwicklereinstellungen.",
  "developersettings.developerOverview": "Entwicklerübersicht",
  "developersettings.manageYourApiKeys": "Verwalten Sie Ihre API-Schlüssel und Webhook-Endpunkte für Drittanbieter-Integrationen.",
  "developersettings.secretApiKeys": "Geheime API-Schlüssel",
  "developersettings.interactiveApiDocumentationRarr": "Interaktive API-Dokumentation &rarr;",
  "developersettings.name": "Name",
  "developersettings.key": "Schlüssel",
  "developersettings.createdAt": "Erstellt am",
  "developersettings.status": "Status",
  "developersettings.actions": "Aktionen",
  "developersettings.webhookEndpoints": "Webhook-Endpunkte",
  "developersettings.url": "URL",
  "developersettings.events": "Ereignisse",
  "developersettings.description": "Beschreibung",
  "developersettings.done": "Fertig",
  "developersettings.addWebhookEndpoint": "Webhook-Endpunkt hinzufügen",
  "developersettings.payloadUrl": "Payload URL",
  "developersettings.eventsToSend": "Zu sendende Ereignisse",
  "developersettings.sendMeEverything": "Alles senden (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "Deal-Status geändert (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "Dokument hochgeladen (document.uploaded)",
  "developersettings.descriptionOptional": "Beschreibung (Optional)",
  "analytics.noDataAvailableFor": "Keine Daten für diesen Zeitraum verfügbar.",
  "analytics.noDealsFound": "Keine Deals gefunden.",
  "analytics.noClientDataAvailable": "Keine Kundendaten für diesen Zeitraum verfügbar.",
  "analytics.client": "Kunde",
  "analytics.invoices": "Rechnungen",
  "analytics.revenue": "Umsatz",
  "analytics.totalPipeline": "Gesamt-Pipeline",
  "analytics.noRecentActivityFor": "Keine aktuellen Aktivitäten für diesen Zeitraum.",
  "analytics.pipelineOverview": "Pipeline-Übersicht",
  "analytics.goToDeals": "Zu Deals",
  "analytics.analyticsDashboard": "Analytics Dashboard",
  "analytics.trackYourBusinessPerformance": "Verfolgen Sie Ihre Geschäftsleistung und Erkenntnisse",
  "analytics.last7Days": "Letzte 7 Tage",
  "analytics.last30Days": "Letzte 30 Tage",
  "analytics.last90Days": "Letzte 90 Tage",
  "analytics.lastYear": "Letztes Jahr",
  "analytics.overview": "Übersicht",
  "analytics.myPerformance": "Meine Leistung",
  "analytics.currentDealsByStatus": "Aktuelle Deals nach Status",
  "analytics.revenueTrendsOverLast": "Umsatztrends der letzten 6 Monate",
  "analytics.accountsGeneratingTheMost": "Konten mit dem höchsten Umsatz",
  "analytics.currentCashFlowOverview": "Aktuelle Cashflow-Übersicht",
  "analytics.latestBusinessActivitiesAnd": "Neueste Geschäftsaktivitäten und Updates",
  "compliance.complianceCenter": "Compliance Center",
  "compliance.hsCodesTariffsSanctions": "HS-Codes, Zölle, Sanktionsprüfung und Exportkontrollen",
  "compliance.hsCodeClassification": "HS-Code-Klassifizierung",
  "compliance.productDescription": "Produktbeschreibung",
  "compliance.tariffCalculator": "Zollrechner",
  "compliance.estimateImportDutiesBased": "Schätzen Sie Einfuhrzölle basierend auf HS-Code und Handelsroute.",
  "compliance.hsCode": "HS-Code",
  "compliance.declaredValueUsd": "Deklarierter Wert (USD)",
  "compliance.originCountry": "Ursprungsland",
  "compliance.destinationCountry": "Bestimmungsland",
  "compliance.dutyRate": "Zollsatz:",
  "compliance.totalRate": "Gesamtsatz:",
  "compliance.estDuty": "Geschätzter Zoll:",
  "compliance.totalEstCost": "Geschätzte Gesamtkosten:",
  "compliance.tradeAgreements": "Handelsabkommen:",
  "compliance.sanctionsScreening": "Sanktionsprüfung",
  "compliance.screenEntitiesAgainstOfac": "Prüfung von Einheiten gegen OFAC SDN-Liste und Ländersanktionen.",
  "compliance.entityName": "Name der Einheit",
  "compliance.type": "Typ",
  "compliance.company": "Unternehmen",
  "compliance.individual": "Einzelperson",
  "compliance.vessel": "Schiff",
  "compliance.countryOptional": "Land (optional)",
  "compliance.usSanctionedCountries": "US-sanktionierte Länder",
  "compliance.exportControlCheck": "Exportkontrollprüfung",
  "compliance.aipoweredEaritarClassificationGuidance": "KI-gestützte EAR/ITAR-Klassifizierungsanleitung. Keine Rechtsberatung.",
  "compliance.producttechnologyDescription": "Produkt-/Technologiebeschreibung",
  "compliance.hsCodeOptional": "HS-Code (optional)",
  "compliance.endUseOptional": "Endverwendung (optional)",
  "compliance.licenseRequired": "Lizenz erforderlich",
  "compliance.recommendations": "Empfehlungen:",
  "compliance.complianceHistory": "Compliance-Verlauf",
  "compliance.recentComplianceChecksFor": "Aktuelle Compliance-Prüfungen für Ihre Organisation.",
  "compliance.noComplianceChecksYet": "Noch keine Compliance-Prüfungen. Führen Sie Ihre erste Prüfung oben durch.",
  "intelligence.marketIntelligence": "Market Intelligence",
  "intelligence.anonymizedTradeDataAnd": "Anonymisierte Handelsdaten und Benchmarks von der PocketFiler-Plattform",
  "intelligence.demandByCategory": "Nachfrage nach Kategorie",
  "intelligence.whatBuyersAreSourcing": "Was Käufer auf der Plattform beschaffen (letzte 90 Tage)",
  "intelligence.noDemandDataYet": "Noch keine Nachfragedaten. Daten werden gefüllt, sobald RFQs auf der Plattform erstellt werden.",
  "intelligence.byIndustry": "Nach Branche",
  "intelligence.noSupplierDataYet": "Noch keine Lieferantendaten.",
  "intelligence.byCountry": "Nach Land",
  "intelligence.byType": "Nach Typ",
  "intelligence.byVerification": "Nach Verifizierung",
  "intelligence.noDataYet": "Noch keine Daten.",
  "intelligence.yourPerformanceVsPlatform": "Ihre Leistung vs. Plattform",
  "intelligence.seeHowYouStack": "Sehen Sie, wie Sie im Vergleich zu Plattform-Durchschnittswerten abschneiden",
  "intelligence.completeSomeDealsTo": "Schließen Sie einige Deals ab, um Benchmarks zu sehen.",
  "virtualoffices.virtualOffices": "Virtuelle Büros",
  "virtualoffices.manageYourBrandedWorkspaces": "Verwalten Sie Ihre markenspezifischen Arbeitsbereiche",
  "virtualoffices.officeName": "Büroname",
  "virtualoffices.industry": "Branche",
  "virtualoffices.languagesServed": "Bediente Sprachen",
  "virtualoffices.descriptionOptional": "Beschreibung (optional)",
  "virtualoffices.documentChecklist": "Dokumentencheckliste",
  "virtualoffices.languages": "Sprachen",
  "tasks.tasks": "Aufgaben",
  "tasks.noTasksYet": "Noch keine Aufgaben",
  "tasks.dragTasksHere": "Aufgaben hierher ziehen",
  "tasks.createNewTask": "Neue Aufgabe erstellen",
  "tasks.descriptionOptional": "Beschreibung (Optional)",
  "tasks.relatedDealOptional": "Zugehöriger Deal (Optional)",
  "tasks.noDealAttached": "Kein Deal angehängt",
  "tasks.assignees": "Beauftragte",
  "tasks.noTeamMembersAvailable": "Keine Teammitglieder verfügbar. Nur aktive Mitglieder können beauftragt werden.",
  "tasks.cancel": "Abbrechen",
  "tasks.description": "Beschreibung",
  "tasks.status": "Status",
  "tasks.relatedDeal": "Zugehöriger Deal",
  "tasks.noAssignees": "Keine Beauftragten",
  "tasks.areYouAbsolutelySure": "Sind Sie sich absolut sicher?",
  "events.events": "Veranstaltungen",
  "events.tradeShowsWebinarsAnd": "Messen, Webinare und Networking-Veranstaltungen",
  "events.createEvent": "Veranstaltung erstellen",
  "events.title": "Titel",
  "events.description": "Beschreibung",
  "events.category": "Kategorie",
  "events.type": "Typ",
  "events.locationUrl": "Standort / URL",
  "events.startDateTime": "Startdatum & -uhrzeit",
  "events.endDateTime": "Enddatum & -uhrzeit",
  "events.maxAttendeesOptional": "Maximale Teilnehmerzahl (optional)",
  "events.cancel": "Abbrechen",
  "events.allCategories": "Alle Kategorien",
  "events.noEventsFoundCreate": "Keine Veranstaltungen gefunden. Erstellen Sie die erste!",
  "events.featured": "Hervorgehoben",
  "events.previous": "Zurück",
  "events.next": "Weiter",
  "status.pendingDocuments": "Ausstehende Dokumente",
  "status.pendingSignature": "Ausstehende Unterschrift",
  "status.pendingPayment": "Ausstehende Zahlung",
  "status.completed": "Abgeschlossen",
  "status.updated": "Aktualisiert",
  "status.onHold": "Pausiert",
  "activity.deal": "Geschäft",
  "activity.action.analyzed": "Analysiert",
  "activity.action.uploaded": "Hochgeladen",
  "activity.action.downloaded": "Heruntergeladen",
  "activity.action.previewed": "Vorschau angezeigt",
  "activity.action.shared": "Geteilt",
  "activity.action.status_changed": "Status geändert",
  "activity.action.updated": "Aktualisiert",
  "activity.action.created": "Erstellt",
  "activity.action.archived": "Archiviert",
  "activity.action.restored": "Wiederhergestellt",
  "analytics.totalRevenue": "Gesamtumsatz",
  "analytics.totalDeals": "Gesamte Geschäfte",
  "analytics.conversionRate": "Konversionsrate",
  "analytics.avgDealValue": "Durchschnittlicher Geschäftswert",
  "analytics.dealPipeline": "Geschäfts-Pipeline",
  "analytics.monthlyRevenue": "Monatlicher Umsatz",
  "analytics.topClientsByRevenue": "Top-Kunden nach Umsatz",
  "analytics.invoiceHealth": "Rechnungsstatus",
  "analytics.paid": "Bezahlt",
  "analytics.pendingPayment": "Ausstehende Zahlung",
  "companyprofile.saveProfile": "Profil speichern",
  "companyprofile.makeVisible": "Machen Sie Ihr Unternehmen im Verzeichnis sichtbar",
  "companyprofile.tab.basicInfo": "Grundlegende Informationen",
  "companyprofile.tab.details": "Details",
  "companyprofile.tab.contact": "Kontakt",
  "companyprofile.tab.team": "Team",
  "companyprofile.tab.verification": "Verifizierung",
  "companyprofile.selectType": "Typ auswählen",
  "companyprofile.describePlaceholder": "Beschreiben Sie Ihr Unternehmen, Ihre Produkte und Dienstleistungen...",
  "companyprofile.industry.other": "Sonstige",
  "companyprofile.preview": "Vorschau",
  "companyprofile.ph.companyName": "Ihr Unternehmen GmbH",
  "companyprofile.ph.tagline": "Qualitätsprodukte, weltweite Reichweite",
  "companyprofile.ph.selectIndustry": "Branche auswählen",
  "companyprofile.ph.selectSize": "Größe auswählen",
  "companyprofile.ph.certifications": "ISO 9001, CE, FDA (durch Komma getrennt)",
  "companyprofile.ph.languages": "Deutsch, Spanisch, Chinesisch",
  "companyprofile.ph.exportRegions": "Nordamerika, Europa, Asien",
  "companyprofile.ph.selectCountry": "Land auswählen",
  "companyprofile.ph.city": "München",
  "companyprofile.ph.teamName": "Name des Teammitglieds",
  "companyprofile.ph.addTitle": "Titel hinzufügen...",
  "companyprofile.inviteTeamMember": "Teammitglied einladen",
  "companyprofile.invitationSent": "Einladung erfolgreich gesendet",
  "virtualoffices.newOffice": "Neues Büro",
  "virtualoffices.createOffice": "Virtuelles Büro erstellen",
  "virtualoffices.reviewChecklist": "Dokumenten-Checkliste überprüfen",
  "virtualoffices.setupDesc": "Richten Sie einen neuen markenspezifischen Arbeitsraum für Ihr Unternehmen ein",
  "virtualoffices.customizeDesc": "Passen Sie die Dokumente an, die Sie von Kunden benötigen",
  "virtualoffices.ph.officeName": "z.B. Garcia Versicherung - Kfz-Policen",
  "virtualoffices.ph.description": "Beschreiben Sie den Schwerpunkt Ihres Büros...",
  "virtualoffices.ph.addDocument": "Benutzerdefiniertes Dokument hinzufügen...",
  "virtualoffices.generating": "Wird generiert...",
  "virtualoffices.aiChecklist": "KI-generierte Checkliste für",
  "virtualoffices.clients": "Kunden",
  "virtualoffices.pending": "Ausstehend",
  "virtualoffices.invite": "Einladen",
  "virtualoffices.ind.manufacturing": "Fertigung",
  "virtualoffices.ind.insurance": "Versicherung",
  "virtualoffices.ind.real_estate": "Immobilien",
  "virtualoffices.ind.automotive": "Automobilbranche",
  "virtualoffices.ind.import_export": "Import/Export",
  "virtualoffices.ind.other": "Sonstige",
  "messages.conversations": "Unterhaltungen",
  "messages.searchPlaceholder": "Nachrichten durchsuchen...",
  "messages.noConversations": "Keine Unterhaltungen",
  "messages.send": "Senden",
  "messages.selectConversation": "Unterhaltung auswählen",
  "messages.selectConversationDesc": "Wählen Sie eine Unterhaltung aus der Seitenleiste aus, um mit dem Chatten zu beginnen",
  "messages.support": "Support",
  "messages.client": "Kunde",
  "messages.deal": "Geschäft",
  "meetings.subtitle": "Videobesprechungen planen und verwalten",
  "meetings.upcoming": "Bevorstehend",
  "meetings.past": "Vergangen",
  "meetings.schedule": "Planen",
  "meetings.startInstant": "Sofort starten",
  "meetings.startNow": "Jetzt starten",
  "meetings.noPast": "Keine vergangenen Besprechungen",
  "meetings.noUpcoming": "Keine bevorstehenden Besprechungen",
  "meetings.createMeeting": "Besprechung erstellen",
  "meetings.startInstantMeeting": "Sofortbesprechung starten",
  "meetings.scheduleMeeting": "Besprechung planen",
  "meetings.scheduleDesc": "Planen Sie eine Videobesprechung und versenden Sie Einladungen.",
  "meetings.invitePeople": "Personen einladen (optional)",
  "meetings.15min": "15 Minuten",
  "meetings.30min": "30 Minuten",
  "meetings.45min": "45 Minuten",
  "meetings.allowRecording": "Aufzeichnung zulassen",
  "meetings.recordingDesc": "Ermöglicht es dem Moderator, diese Besprechung aufzuzeichnen",
  "meetings.waitingRoom": "Warteraum",
  "meetings.waitingRoomDesc": "Teilnehmer müssen vom Moderator zugelassen werden, bevor sie beitreten können",
  "meetings.emailPlaceholder": "email@beispiel.com",
  "meetings.cancelConfirm": "Diese Besprechung absagen?",
  "meetings.cancelMeeting": "Besprechung absagen",
  "documents.title": "Dokumente",
  "documents.viewAll": "Alle anzeigen",
  "documents.archived": "Archiviert",
  "documents.requestDocs": "Dokumente anfordern",
  "documents.upload": "Hochladen",
  "documents.allDocuments": "Alle Dokumente",
  "documents.searchPlaceholder": "Dokumente durchsuchen...",
  "documents.addTag": "Tag hinzufügen...",
  "documents.uploadDesc": "Dateien per Drag & Drop ziehen oder zum Durchsuchen klicken. PDF, Bilder, Word-Dokumente werden unterstützt.",
  "documents.emailPlaceholder": "kunde@beispiel.de",
  "documents.shareMsgPlaceholder": "Hier ist das von Ihnen angeforderte Dokument...",
  "documents.requestDesc": "Einen sicheren Upload-Link per E-Mail an einen Kunden senden.",
  "documents.namePlaceholder": "Max Mustermann",
  "documents.requestMsgPlaceholder": "Bitte laden Sie die folgenden Dokumente hoch...",
  "documents.folderName": "Ordnername",
  "documents.selectDestination": "Einen Zielordner auswählen.",
  "documents.statusUploaded": "Hochgeladen",
  "documents.statusAnalyzed": "Analysiert",
  "documents.statusArchived": "Archiviert",
  "documents.allTypes": "Alle Typen",
  "documents.inArchive": "im Archiv",
  "templates.allTemplates": "Alle Vorlagen",
  "templates.editTemplate": "Vorlage bearbeiten",
  "templates.createCustomTemplate": "Benutzerdefinierte Vorlage erstellen",
  "templates.editDesc": "Ihre Dokumentvorlage aktualisieren",
  "templates.createDesc": "Ihre eigene wiederverwendbare Dokumentvorlage erstellen",
  "templates.ph.templateName": "z.B. Benutzerdefinierte Geheimhaltungsvereinbarung",
  "templates.ph.description": "Kurze Beschreibung der Vorlage",
  "templates.ph.content": "Geben Sie hier Ihren Vorlageninhalt ein...",
  "templates.saving": "Speichere...",
  "templates.creating": "Erstelle...",
  "templates.saveChanges": "Änderungen speichern",
  "templates.createTemplate": "Vorlage erstellen",
  "templates.searchPlaceholder": "Vorlagen durchsuchen...",
  "templates.popularTemplates": "Beliebte Vorlagen",
  "templates.defaultTemplates": "Standardvorlagen",
  "templates.deleteTemplate": "Vorlage löschen",
  "templates.preview": "Vorschau",
  "templates.description": "Beschreibung",
  "products.searchPlaceholder": "Produkte suchen...",
  "products.ph.service": "Beratungsdienstleistungen",
  "products.ph.product": "Widget Pro 3000",
  "products.selectCategory": "Kategorie auswählen",
  "products.ph.describe": "Beschreiben Sie Ihr Produkt oder Ihre Dienstleistung...",
  "products.noMatches": "Keine Übereinstimmungen gefunden",
  "products.noProducts": "Noch keine Produkte oder Dienstleistungen",
  "products.serviceDetails": "Dienstleistungsdetails",
  "products.productDetails": "Produktdetails",
  "products.inactive": "Inaktiv",
  "products.deleteConfirm": "Diesen Artikel löschen?",
  "products.saveChanges": "Änderungen speichern",
  "products.addItem": "Artikel hinzufügen",
  "products.priceOnRequest": "Preis auf Anfrage",
  "products.perUnit": "Pro Einheit",
  "tasks.searchPlaceholder": "Aufgaben suchen...",
  "tasks.ph.title": "z.B. Rechtsdokumente prüfen",
  "tasks.ph.description": "Mehr Kontext zu dieser Aufgabe hinzufügen...",
  "tasks.selectDeal": "Ein Geschäft zum Verknüpfen auswählen",
  "tasks.noTasks": "Keine Aufgaben in dieser Spalte",
  "tasks.deleteTask": "Aufgabe löschen",
  "settings.tabs.branding": "Branding",
  "settings.tabs.payments": "Zahlungen",
  "settings.tabs.plan": "Tarif",
  "settings.tabs.integrations": "Integrationen",
  "settings.appearance": "Erscheinungsbild",
  "settings.saveBranding": "Branding speichern",
  "settings.yourPlan": "Ihr Tarif",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "Kalender-Feed-URL wurde generiert!",
  "settings.plan.free": "Kostenlos",
  "settings.plan.pro": "Pro",
  "settings.plan.smallBusiness": "Kleinunternehmen",
  "settings.plan.businessPro": "Business Pro",
  "settings.plan.scale": "Scale",
  "settings.plan.enterprise": "Enterprise",
  "dealroom.meetings": "Besprechungen",
  "dealroom.startMeeting": "Besprechung starten",
  "dealroom.noMeetings": "Diesem Geschäft sind noch keine Besprechungen zugeordnet",
  "dealroom.noMeetingsDesc": "Starten oder planen Sie eine Besprechung, um zu beginnen",
  "dealroom.failedCreateMeeting": "Erstellen der Besprechung fehlgeschlagen",
  "dealroom.finalizedContract": "Finalisierter Vertrag — Bereit zur Unterzeichnung",
  "dealroom.previewNotSupported": "Vorschau wird nicht unterstützt",
  "dealroom.aiMayTakeMoment": "Dies kann einen Moment dauern.",
  "dealroom.aiAnalysisGenerated": "KI-Analyse wurde für die folgenden Dokumente erstellt:",
  "dealroom.docsUnanalyzed": "Die folgenden Dokumente sind noch nicht analysiert:",
  "dealroom.analyzingDocs": "Dokumente werden analysiert...",
  "dealroom.finalizeWarning": "Diese Aktion kann nicht rückgängig gemacht werden. Der Geschäftsstatus wird zu Ausstehende Unterzeichnung geändert und alle Parteien können den Vertrag unterzeichnen.",
  "dealroom.cannotRevert": "Rückkehr von Ausstehende Unterzeichnung nicht möglich",
  "compliance.ph.productDesc": "z.B. Edelstahlschrauben, M10 x 50mm...",
  "compliance.ph.exportDesc": "Beschreiben Sie das zu exportierende Produkt oder die Technologie...",
  "compliance.select": "Auswählen...",
  "compliance.selectCountry": "Land auswählen...",
  "events.tradeShow": "Fachmesse",
  "events.webinar": "Webinar",
  "events.networking": "Networking",
  "events.conference": "Konferenz",
  "events.workshop": "Workshop",
  "events.ph.title": "Veranstaltungstitel",
  "events.ph.location": "Veranstaltungsort oder Meeting-URL",
  "events.ph.maxAttendees": "Leer lassen für unbegrenzte Teilnehmerzahl",
  "events.searchPlaceholder": "Veranstaltungen suchen...",
  "events.cancelRsvp": "RSVP stornieren",
  "events.rsvp": "RSVP",
  "rfq.expired": "Abgelaufen",
  "rfq.createRfq": "Angebotsanfrage erstellen",
  "rfq.visibility": "Sichtbarkeit",
  "rfq.public": "Öffentlich - Alle Lieferanten können es einsehen",
  "rfq.private": "Privat - Nur auf Einladung",
  "rfq.quantity": "Menge",
  "rfq.unit": "Einheit",
  "rfq.pieces": "Stück",
  "rfq.kilograms": "Kilogramm",
  "rfq.meters": "Meter",
  "rfq.squareMeters": "Quadratmeter",
  "rfq.units": "Einheiten",
  "rfq.sets": "Sets",
  "rfq.boxes": "Kartons",
  "rfq.deliveryLocation": "Lieferort",
  "rfq.deliveryDeadline": "Liefertermin",
  "rfq.specialRequirements": "Besondere Anforderungen",
  "rfq.title": "Angebotsanfragen",
  "rfq.subtitle": "Durchsuchen Sie Beschaffungsanfragen oder stellen Sie Ihre eigene ein",
  "rfq.rfqsPosted": "Veröffentlichte RFQs",
  "rfq.openRfqs": "Offene RFQs",
  "rfq.quotesSent": "Gesendete Angebote",
  "rfq.winRate": "Erfolgsquote",
  "rfq.allCategories": "Alle Kategorien",
  "rfq.noRfqsFound": "Keine RFQs gefunden",
  "rfq.noRfqsYet": "Noch keine RFQs vorhanden",
  "meetings.biweekly": "Alle 2 Wochen",
  "meetings.cancelSeries": "Gesamte Serie absagen",
  "meetings.cancelThisMeeting": "Dieses Meeting absagen",
  "meetings.nextInSeries": "Nächstes in der Serie",
  "nav.contractTemplates": "Verträge",
  "contracts.title": "Vertragsvorlagen",
  "contracts.subtitle": "KI-gestützte Erstellung von Rechtsdokumenten. Wählen Sie eine Vorlage.",
  "documents.create": "Erstellen",
  "createDoc.untitledDocument": "Unbenanntes Dokument",
  "createDoc.save": "Speichern",
  "createDoc.export": "Exportieren",
  "createDoc.aiAssist": "KI-Assistent",
  "createDoc.generate": "Generieren",
  "createDoc.generating": "Wird generiert...",
  "createDoc.cancel": "Abbrechen",
  "createDoc.translate": "Übersetzen",
  "createDoc.translateTitle": "Dokument übersetzen",
  "createDoc.translateTo": "Übersetzen in",
  "createDoc.translateNow": "Übersetzen",
  "createDoc.translating": "Übersetzung...",
  "createDoc.translated": "Dokument erfolgreich übersetzt",
  "createDoc.translateFailed": "Übersetzung fehlgeschlagen",
  "verification.status": "Verifizierungsstatus",
  "verification.inProgress": "Verifizierung Läuft",
  "verification.getVerified": "Verifizieren",
  "verification.cancelRequest": "Anfrage Stornieren",
  "verification.submit": "Zur Verifizierung Einreichen",
  "verification.submitting": "Wird gesendet...",
  "verification.uploadDocs": "Dokumente Hochladen",
  "verification.level": "Verifizierungsstufe",
  "verification.selectDocType": "Dokumenttyp auswählen...",
  "contracts.generate": "Generieren",
  "contracts.backToTemplates": "Zurück zu Vorlagen",
  "contracts.required": "Erforderlich",
  "contracts.modify": "Ändern",
  "contracts.finalize": "Abschließen",
  "contracts.applyChanges": "Änderungen anwenden",
  "contracts.confirmDelete": "Entwurf löschen?",
  "contracts.generating": "Dokument wird erstellt...",
  "contracts.nda": "Gegenseitige Geheimhaltungsvereinbarung",
  "contracts.sow": "Leistungsbeschreibung",
  "contracts.msa": "Rahmendienstleistungsvertrag",
  "contracts.contractor": "Freiberuflervertrag",
  "contracts.loi": "Absichtserklärung",
  "templates.deleting": "Wird gelöscht...",
  "templates.noDescription": "Keine Beschreibung.",
  "templates.use": "Verwenden",
  "templates.confirmDeleteDesc": "Diese Vorlage wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
  "templates.lib.ndaMutual": "Gegenseitige Geheimhaltung",
  "templates.lib.ndaMutualDesc": "Standard-Geheimhaltungsvereinbarung zum Schutz vertraulicher Informationen zwischen zwei Parteien.",
  "templates.lib.purchaseAgreement": "Kaufvertrag",
  "templates.lib.purchaseAgreementDesc": "Standard-Kaufvertragsvorlage für B2B-Produktverkäufe mit Geschäftsbedingungen.",
  "templates.lib.serviceAgreement": "Dienstleistungsvertrag",
  "templates.lib.serviceAgreementDesc": "Vorlage für professionelle Dienstleistungsvereinbarung mit Leistungsumfang.",
  "templates.lib.priceQuote": "Preisangebot",
  "templates.lib.priceQuoteDesc": "Professionelle Angebotsvorlage für die Preisgestaltung an potenzielle Kunden.",
  "templates.lib.invoice": "Rechnung",
  "templates.lib.invoiceDesc": "Professionelle Rechnungsvorlage für Kundenabrechnung und Zahlungsverfolgung.",
  "templates.lib.loi": "Absichtserklärung",
  "templates.lib.loiDesc": "Vorlage für Absichtserklärung zum Ausdruck von Interesse an einer Geschäftsvereinbarung.",
  "settings.security": "Sicherheit",
  "security.twoFactor": "Zwei-Faktor-Authentifizierung",
  "security.enabled": "Aktiviert",
  "security.disabled": "Deaktiviert",
  "security.enable2FA": "2FA Aktivieren",
  "security.disable": "Deaktivieren",
  "security.activeSessions": "Aktive Sitzungen",
  "security.logoutAll": "Überall abmelden",
  "security.lastUsed": "Zuletzt verwendet",
  "security.currentSession": "Aktuell",
  "security.loginHistory": "Anmeldeverlauf",
  "security.successfulLogin": "Erfolgreiche Anmeldung",
  "security.failedLogin": "Fehlgeschlagener Versuch",
  "security.verify": "Verifizieren",
  "security.cancel": "Abbrechen",
  "security.password": "Passwort",
  "security.done": "Fertig",
  "feedback.button": "Feedback",
  "feedback.title": "Feedback Senden",
  "feedback.typeBug": "Fehler",
  "feedback.typeFeature": "Funktion",
  "feedback.typeGeneral": "Allgemein",
  "feedback.descPlaceholder": "Erzählen Sie uns, was passiert ist...",
  "feedback.priorityLow": "Niedrig",
  "feedback.priorityMedium": "Mittel",
  "feedback.priorityHigh": "Hoch",
  "feedback.submit": "Senden",
  "feedback.thanks": "Danke! Wir kümmern uns darum.",
};

export default de;
